import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { InstallationHttpClient } from "@e-forsyning/common/http";

import { MaalerType } from "../model/maaler-type.model";
import { MaalerTypeDbMapper } from "./maaler-type-db-mapper";

@Injectable({ providedIn: "root" })
export class MaalerTypeRepository {
    constructor(private readonly http: InstallationHttpClient) {}

    public hentMaalerTyper(): Observable<MaalerType[]> {
        const result$ = this.http
            .get("api/getmaalertyper?medtagPassive=1")
            .pipe(map((result: any) => MaalerTypeDbMapper.dbToMaalerTyper(result.maalertyper)));
        return result$;
    }
}
